import { useCallback, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { markNotificationRead } from "../../actions/notificationActions";
import { openFloatingChat } from "../../utils/openFloatingChat";
import { CHAT_DOCUMENT_ACCEPT as DOCUMENT_ACCEPT } from "../../utils/mediaDocument";

/*
 * Настройки чата для ФРОНТА. Файлы чата (ChatCore, ChatMessages, InputChatUI
 * и другие в этой папке) одинаковые в админке и на фронте — всё, чем
 * проекты отличаются, собрано здесь. У админки этот файл свой.
 */

const getId = (value) => String(value?._id || value || "");

// Задач на фронте нет — пункта «В задачу» не будет.
export const TodoFromMessageModal = null;

// Товары и заказы сайта отправляет только админка; здесь — объекты офиса.
export const CHAT_SITE_CATALOG = false;

// «Файлы»: PDF, Excel/ODS/CSV, Word, 1С, архивы.
export const CHAT_DOCUMENT_ACCEPT = DOCUMENT_ACCEPT;

// Профиль участника (имя отправителя в группе): карточка, как из шапки чата.
export { default as ChatUserProfileModal } from "../../components/UserProfile/UserProfileModal";

// Кнопка «в плавающее окно» в шапке чата.
export const openChatFloating = openFloatingChat;

const getNotificationChatId = (notification) => (
    notification?.meta?.chatId ||
    notification?.meta?.targetChatId ||
    notification?.chatId ||
    notification?.targetChatId ||
    null
);

const getNotificationOfficeId = (notification) => (
    notification?.office?._id ||
    notification?.office?.id ||
    notification?.office ||
    notification?.officeId ||
    notification?.meta?.officeId ||
    null
);

/**
 * Прочитали чат — закрываем и его непрочитанные уведомления: счётчики
 * сообщений и уведомлений двигаются вместе.
 */
export const useChatReadExtras = (chatId) => {
    const dispatch = useDispatch();
    const notifications = useSelector(
        (state) => state.notification?.notifications || [],
        shallowEqual
    );
    // Функция не меняется от каждого нового уведомления: берёт свежий список отсюда.
    const notificationsRef = useRef(notifications);
    notificationsRef.current = notifications;

    return useCallback(() => {
        (notificationsRef.current || [])
            .filter((notification) => (
                !notification?.isRead &&
                getId(getNotificationChatId(notification)) === getId(chatId)
            ))
            .forEach((notification) => {
                const notificationId = notification?._id || notification?.id;
                if (!notificationId) return;

                dispatch(markNotificationRead(notificationId, {
                    scope: notification.scope || "personal",
                    officeId: getNotificationOfficeId(notification) || undefined,
                }));
            });
    }, [chatId, dispatch]);
};
